// Middleware
import AuthMiddleware from '@middleware/AuthMiddleware';
import GuestMiddleware from '@middleware/GuestMiddleware';

// Layouts
import LayoutAuth from '@layouts/LayoutAuth';

export default {
    path: '/',
    component: LayoutAuth,
    children: [
        {
            path: 'login',
            name: 'login',
            component: () => import('@pages/auth/PageAuthLogin'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.log_in',
            },
        },
        {
            path: 'signup',
            name: 'signup',
            component: () => import('@pages/auth/PageAuthSignup'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.sign_up',
            },
        },
        {
            path: 'password-reset',
            name: 'password-reset',
            component: () => import('@pages/auth/PageAuthPasswordReset'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.reset_password',
            },
        },
        {
            path: 'password-change/:temp_token',
            name: 'password-change',
            component: () => import('@pages/auth/PageAuthPasswordChange'),
            meta: {
                middleware: GuestMiddleware,
                title: 'titles.change_password',
            },
        },
        {
            path: 'project-setup',
            name: 'project-setup',
            component: () => import('@pages/auth/PageAuthProject'),
            meta: {
                middleware: AuthMiddleware,
                title: 'titles.project_setup',
            },
        },
        {
            path: 'oauth/consent',
            name: 'oauth.consent',
            component: () => import('@pages/auth/PageOauthConsent'),
            meta: {
                middleware: AuthMiddleware,
                title: 'titles.authorize',
            },
        },
        {
            path: 'verify-email/:temp_token',
            name: 'verify-email',
            component: () => import('@pages/auth/PageAuthVerifyEmail'),
            meta: {
                title: 'titles.verify_email_address',
            },
        },
        {
            path: 'accept-invite/:token',
            name: 'accept-invite',
            component: () => import('@pages/auth/PageAuthAcceptInvite'),
            meta: {
                title: 'titles.accept_invite',
            },
        },
        {
            path: 'mfa',
            name: 'mfa',
            component: () => import('@pages/auth/PageAuthMFA'),
            meta: {
                title: 'titles.two_factor_authentication',
            },
        },
    ],
};